"use strict";
/**
 * Copyright (c) Haiku 2016-2018. All rights reserved.
 */
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * @method isMutableProperty
 * @description Mechanism to determine if a property is mutated within the timeline.
 */
function isMutableProperty(property, propertyName) {
    // For now, we can use a "naive" set of sufficient (but not necessary) conditions for immutability of a property:
    //   1. Has exactly one keyframe.
    //   2. The keyframe is "0".
    //   3. The value at keyframe "0" is not a function (and so it cannot be mutated by changes in the state container).
    // Although there is a more complete definition of immutability, this is enough to identify a property which is
    // "likely mutable".
    return Object.keys(property).length !== 1
        || !property.hasOwnProperty('0')
        || typeof property[0].value === 'function'
        || /^controlFlow/.test(propertyName);
}
exports.default = isMutableProperty;
//# sourceMappingURL=isMutableProperty.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@haiku/core/lib/helpers/isMutableProperty.js
// module id = 112
// module chunks = 35783957827783 127651196306611 162898551421021